import Button from "app/components/Button";
import Modal from "app/components/Modal";
import { useQueryState } from "nuqs";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../redux/slice";
import { actions as actionsTicket } from "../../containers/Tickets/redux/slice";
import AddTaskModalContent from "./AddTaskModalContent";
import AddTaskHeader from "../AddTaskHeader";
import DraftModal from "./draft-modal";
import {
  selectTicketCreateLoading,
  selectTicketFormDetail,
} from "../../containers/Tickets/redux/selector";
import { useParams } from "react-router-dom";

interface AddTaskModalProps {
  onClose: () => void;
  isDrafted?: boolean;
}

export default function AddTaskModal({
  onClose,
  isDrafted,
}: AddTaskModalProps) {
  const params = useParams();
  const loading = useSelector(selectTicketCreateLoading);
  const form = useSelector(selectTicketFormDetail);
  const [draftId, setDraftId] = useQueryState("did");
  const [deleteDraft, setDeleteDraft] = useState(false);
  const dispatch = useDispatch();
  const handleClose = () => {
    if (isDrafted) {
      setDeleteDraft(true);
      return;
    } else {
      onClose();
    }
  };
  const handleSetDraft = () => {
    onClose();
    dispatch(actions.setDraftTicket());
  };
  const handleRemoveDraft = (id: string) => {
    dispatch(actions.removeDraftTicket({ id: id }));
    setDeleteDraft(false);
    setDraftId(null);
  };
  const handleCreateTicket = () => {
    dispatch(
      actionsTicket.setCreateTicket({
        projectId: params.project as string,
        boardId: params.id as string,
        groupId: "",
        callback: () => {
          onClose();
          // onShowAddTask();
        },
      })
    );
  };

  return (
    <>
      <Modal
        onClose={handleClose}
        submitText="Add"
        title={isDrafted ? "Task Draft" : "Add task"}
        contentClassName="!p-0 !max-h-[50vh] overflow-y-auto"
        modalClassName="!w-[721px] !max-w-[721px]"
        renderModalHeader={
          <AddTaskHeader
            isDrafted={isDrafted as boolean}
            handleSetDraft={handleSetDraft}
            handleClose={handleClose}
            handleRemoveDraft={() => {
              handleRemoveDraft(draftId as string);
            }}
          />
        }
        footerRender
        renderModalFooter={
          <div className={"flex justify-end items-center gap-4"}>
            <>
              <button
                onClick={onClose}
                type="button"
                className="bg-[transparent] text-secondary border border-secondary rounded-[4px] w-[106px] h-[36px] text-sm leading-[21px] font-normal text-center !p-0"
              >
                Cancel
              </button>
              <Button
                disabled={!form.title}
                isLoading={loading}
                onClick={handleCreateTicket}
                className=" w-[106px] h-[36px] text-center !p-0"
              >
                Save
              </Button>
            </>
          </div>
        }
      >
        <AddTaskModalContent />
      </Modal>
      {deleteDraft && (
        <DraftModal
          setDeleteDraft={setDeleteDraft}
          handleRemoveDraft={() => {
            handleRemoveDraft(draftId as string);
          }}
          onClose={onClose}
          setDraftId={setDraftId}
        />
      )}
    </>
  );
}
